@use '../mixins';

a {
  display: inline-block;
  margin: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  // Anchor/Link Resets
  color: inherit;
  font-family: inherit;
  font-size: 100%;
  line-height: normal;
  text-decoration: none;
  vertical-align: baseline;
  cursor: pointer;
  appearance: unset;

  &:disabled {
    cursor: default;
  }
}

.link {
  --color-hover: var(--light-blue-500);
  --color-active: var(--color-orange-1);

  --color-primary: #fff;
  --color-disabled-primary: #fff;
  --bg-color-default-primary: var(--color-orange-1);
  --bg-color-hover-primary: #db8a21;
  --bg-color-disabled-primary: #efc289;

  --color-secondary: #fff;
  --color-disabled-secondary: #fff;
  --bg-color-default-secondary: var(--dark-blue-500);
  --bg-color-hover-secondary: #031732;
  --bg-color-disabled-secondary: var(--dark-blue-300);

  --color-tertiary: var(--dark-blue-500);
  --color-disabled-tertiary: var(--dark-blue-300);
  --bg-color-default-tertiary: var(--dark-blue-200);
  --bg-color-hover-tertiary: var(--dark-blue-500);
  --bg-color-disabled-tertiary: var(--dark-blue-300);
  -webkit-transition: color 100ms linear;
  -moz-transition: color 100ms linear;
  -o-transition: color 100ms linear;
  transition: color 100ms linear;
  text-align: center;

  &:hover,
  &:focus {
    color: var(--color-hover);
  }

  &.inline {
    color: currentColor;
    font-weight: bold;

    &:hover,
    &:focus {
      color: var(--color-hover);
      text-decoration: underline;
    }
  }

  &.nav {
    padding-bottom: 0.25em;
    border-bottom: 0.125em solid transparent;
    font-size: var(--font-size-nav);
    font-weight: bold;
    letter-spacing: 0.1563em;
    text-transform: uppercase;

    &:hover,
    &:focus {
      padding-bottom: 0.25em;
      border-bottom: 0.125em solid var(--color-active);
      color: var(--color-active);
    }

    &.active {
      padding-bottom: 0.25em;
      border-bottom: 0.125em solid var(--color-active);
      color: var(--color-active);
    }
  }

  &.bold {
    font-weight: bold;
  }

  &.small {
    font-size: var(--font-size-nav);
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  &.underlined {
    text-decoration: underline;
  }

  &.primary {
    @include mixins.cta-intent-styles-generator(
      var(--color-primary),
      var(--bg-color-default-primary),
      var(--color-disabled-primary),
      var(--bg-color-disabled-primary),
      var(--bg-color-hover-primary)
    );
  }

  &.secondary {
    @include mixins.cta-intent-styles-generator(
      var(--color-secondary),
      var(--bg-color-default-secondary),
      var(--color-disabled-secondary),
      var(--bg-color-disabled-secondary),
      var(--bg-color-hover-secondary)
    );
  }

  &.tertiary {
    @include mixins.outlined-cta-intent-styles-generator(
      var(--color-tertiary),
      var(--bg-color-default-tertiary),
      var(--color-disabled-tertiary),
      var(--bg-color-disabled-tertiary),
      var(--bg-color-hover-tertiary)
    );
  }
}
